import { makeStyles } from '@mui/styles';
import { theme } from '~/theme/default';
export const useStyles = makeStyles(() => ({
    dialogContainer: {
        '&.MuiDialog-root': {
            top: 'initial',
            maxHeight: '100vh',
        },
    },
    title: {
        fontWeight: 600,
        color: theme.palette.text.primary,
        textAlign: 'center',
        width: '100%',
        paddingLeft: '48px',
    },
    button: {
        padding: '4px 0 4px',
    },
    clearButton: {
        '&.MuiButton-root, &.MuiButton-root:hover': {
            marginTop: '4px',
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.text.secondary,
            fontWeight: 700,
        },
    },
}));
